import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppUser } from '../appUser';

type UserMaintenanceState = {
  selectedUser: AppUser | null;
};

const initialState: UserMaintenanceState = {
  selectedUser: null,
};

export const userMaintenanceSlice = createSlice({
  name: 'userMaintenanceSlice',
  initialState,
  reducers: {
    setSelectedUser: (state, action: PayloadAction<AppUser | null>) => {
      state.selectedUser = action.payload;
    },
  },
});

export const { setSelectedUser } = userMaintenanceSlice.actions;
